import Vue from 'vue';
import accountTransformer from './../../transformers/custom/accountSetup';
import accountService from './../account';

const success = (token, resolve) => {
  accountService.find();
  Vue.router.push({
    name: 'dashboard',
  });
  resolve();
};

const failed = (errors, reject) => {
  reject(accountTransformer.fetch(errors));
};

export default user => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('auth/register', user)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/auth/register.js